import axios from 'axios';

async function deleteRevisionRequest(user, revision) {
  if (!user || !user.institution?.id) {
    throw new Error("deleteRevisionRequest(): missing user data");
  }
  if (!revision.__syncedWithBackend) {
    throw new Error("deleteRevisionRequest(): revision is not present in the backend");
  }
  await axios.delete(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/CourseRevisions/${encodeURIComponent(revision.id)}`);
}

export { deleteRevisionRequest };
//# sourceMappingURL=request.delete.js.map
